import { useRef } from "react"
import "./ModulePageDrawer.css"
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer"
import { closeModulePageDrawer, useGlobal } from "../../../core/Global"
import Switch from "../../../Switch"

// Rendered at App level (outside <Switch>) so its <Routes location> sits at the
// router root (base "/") and can match any absolute path.
export default function ModulePageDrawer() {

    const drawer = useRef<DrawerRef>(null)
    const [globalState] = useGlobal()

    const item = globalState.modulePageDrawer
    if (!item) return null

    // Surface the page's own toolbar actions (Add buttons, etc.) into the drawer
    // header, since we hide the page's PageTitleBar to avoid a duplicate title.
    const Actions = globalState.toolbarActions

    return (
        <Drawer ref={drawer} title={item.title} noPadding
            toolbarComponent={Actions ? () => <Actions /> : undefined}
            onClose={closeModulePageDrawer}>
            <div className="module-page-drawer">
                <Switch location={item.link} />
            </div>
        </Drawer>
    )
}
